module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('industry-single', {
    scopedSlots: _vm._u([{
      key: "hero",
      fn: function() {
        return [_c('hero-full', {
          attrs: {
            "imageName": "industries/farming-banner.jpg",
            "altText": "Farmer"
          },
          scopedSlots: _vm._u([{
            key: "content",
            fn: function() {
              return [_c('h1', [_vm._v("Farm Loans")]), _vm._v(" "), _c('p', [_vm._v("Farming Business Financing & Equipment Loans")])]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "form-section",
      fn: function() {
        return [_c('FormSection', {
          scopedSlots: _vm._u([{
            key: "content",
            fn: function() {
              return [_c('h2', [_c('span', [_vm._v("American Credit:")]), _vm._v(" Empowering Farmers everyday with\n          Farming Business Financing.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          Farming is in your blood. It’s what you do. The Farming industry is\n          filled with tough & resilient individuals, however, businesses can\n          only withstand so many hardships & difficulties. Severe labor\n          shortages, access to quality farming equipment, supply chain issues\n          & rising energy prices are just a few of the major issues facing the\n          Farming Industry."), _c('br'), _c('br'), _vm._v("\n\n          American Credit is committed to serving America’s farmers with quick\n          farming business loans & immediate working capital. Read on and see\n          how American Credit helps farmers just like you get back on their\n          feet and get back to work.\n        ")])]
            },
            proxy: true
          }, {
            key: "logos",
            fn: function() {
              return [_c('div', {
                staticClass: "row"
              }, [_c('div', {
                staticClass: "col-12 col-md-5 order-md-2 d-flex"
              }, [_c('div', {
                staticClass: "row align-items-center logos-brands"
              }, [_c('div', {
                staticClass: "col-6 col-md-12"
              }, [_c('img', {
                attrs: {
                  "src": "/static/assets/imgs/industries/nefa-logo.png",
                  "alt": "NEFA logo"
                }
              })]), _vm._v(" "), _c('div', {
                staticClass: "col-6 col-md-12"
              }, [_c('a', {
                attrs: {
                  "href": "https://www.bbb.org/us/ca/palo-alto/profile/financial-services/american-credit%C2%AE-inc-1216-1079741",
                  "target": "_blank"
                }
              }, [_c('img', {
                attrs: {
                  "src": "/static/assets/imgs/industries/bbba-logo.png",
                  "alt": "BBBA logo"
                }
              })])])])]), _vm._v(" "), _c('div', {
                staticClass: "col-12 col-md-7"
              }, [_c('img', {
                attrs: {
                  "src": "/static/assets/imgs/industries/google-review.png",
                  "alt": "Google Review"
                }
              })])])]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "first-row",
      fn: function() {
        return [_c('RowSection', {
          attrs: {
            "img-side": "left",
            "imageName": "industries/farming-equipment-loans.jpg",
            "altText": "Farming Machine",
            "backgroundPrimary": "#00234D",
            "backgroundSecondary": "#F6F9FE"
          },
          scopedSlots: _vm._u([{
            key: "content",
            fn: function() {
              return [_c('h2', [_vm._v("Instant Farm Equipment Loans")]), _vm._v(" "), _c('p', [_vm._v("\n          Farmers push their equipment to the limits everyday. The importance\n          of having dependable & reliable farming equipment is undeniable.\n          Anytime you need to replace broken equipment, or scale your business\n          with more brand new farming equipment, we are ready to help."), _c('br'), _c('br'), _vm._v("\n\n          Use your Farming Equipment loan to purchase tillage equipment such\n          as plows, cultivators, harrows, or planting equipment such as\n          tractors, fertilizer spreaders or harvesters. Business owners also\n          use their farming equipment loan to purchase crop irrigation\n          equipment, agricultural sprayers & monitoring sensors, backhoes,\n          dozers & excavators. Whatever your equipment needs may be, American\n          Credit supports farmers with quick & easy farming business loans.\n        ")])]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "second-row",
      fn: function() {
        return [_c('RowSection', {
          attrs: {
            "img-side": "right",
            "imageName": "industries/farming-working-capital.jpg",
            "altText": "Farming Workers"
          },
          scopedSlots: _vm._u([{
            key: "content",
            fn: function() {
              return [_c('h2', [_vm._v("Farming Working Capital Solutions")]), _vm._v(" "), _c('p', [_vm._v("\n          Farming is often unpredictable. Just when business is flourishing,\n          sudden changes in weather can completely ruin everything. Random\n          weather issues, coupled with labor shortages, inflation, and\n          restraining government regulations, are all very real issues that\n          farmers face everyday. In these uncertain times, American Credit\n          provides certainty to help your business survive. "), _c('br'), _c('br'), _vm._v("\n\n          Use your Farming Working Capital Loan to pay employees, invest in\n          new land & technology, and sustain your business during harsh slow\n          seasons. American Credit understands the farming industry. Our\n          lending experts have over 20+ years experience assisting farmers\n          just like you with working capital solutions. Apply for your Farming\n          Business Loan today!\n        ")])]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "third-row",
      fn: function() {
        return [_c('IconsGrid', {
          attrs: {
            "gridElements": _vm.gridItems
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function() {
              return [_vm._v("Geared to Your Needs and Your Business")]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "fourth-row",
      fn: function() {
        return [_c('TablesSection', {
          attrs: {
            "tables": _vm.tableItems
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function() {
              return [_vm._v("Farm Loan Requirements")]
            },
            proxy: true
          }, {
            key: "text",
            fn: function() {
              return [_vm._v("Minimum loan requirements to expedite approval & secure quick\n        funding.")]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "fifth-row",
      fn: function() {
        return [_c('RowSection', {
          staticClass: "lei-section",
          attrs: {
            "img-side": "right",
            "imageName": "industries/Lei-li-formal.jpeg",
            "altText": "photo Dr. Lei Li, CEO of American Credit, Inc., in blue suit smiling"
          },
          scopedSlots: _vm._u([{
            key: "content",
            fn: function() {
              return [_c('h2', [_c('span', [_vm._v("American Credit:")]), _vm._v(" The Difference You Can Trust")]), _vm._v(" "), _c('p', [_vm._v("\n          Your business is not JUST a business. It’s YOURS. It’s your\n          livelihood. It’s your passion. American Credit completely\n          understands this. We help business owners just like you everyday, by\n          taking a wholistic approach to business financing.\n          "), _c('strong', [_vm._v("Dr. Lei Li, PhD, CFA, & CEO of American Credit")]), _vm._v(", is\n          an Economist who uses his 20+ years of industry experience to help\n          business owners achieve their American Dream:\n          "), _c('strong', [_vm._v("successful business ownership")]), _vm._v(". "), _c('br'), _c('br'), _vm._v("\n          Whatever financial situation you’re in, American Credit has your\n          back. Apply for your business loan today!\n        ")])]
            },
            proxy: true
          }, {
            key: "button-contact",
            fn: function() {
              return [_c('contact-info', {
                staticClass: "d-none d-md-flex",
                attrs: {
                  "imageName": "Lei_Li.png",
                  "altText": "Lei's photo",
                  "title": "Call Lei",
                  "contactType": "Service",
                  "phoneNumber": "650-885-8055"
                }
              })]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "google-reviews",
      fn: function() {
        return [_c('div', {
          staticClass: "elfsight-app-8279c03d-9a65-4465-b949-ecb8d18697e0"
        })]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-793a2f59"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/industries/loansForFarmers.vue
// module id = 1996
// module chunks = 5